import React from "react"
import "react-dates/initialize"
import "react-dates/lib/css/_datepicker.css"
import { DateRangePicker } from "react-dates"
import "./DateRangePicker.scss"
import { FormHelperText } from "@mui/material"

function AppDateRange({
  startDate,
  endDate,
  focusedInput,
  handleDatesChange,
  handleFocusChange,
  minimumNights = 0,
  startDatePlaceholderText = "Start Date",
  endDatePlaceholderText = "End Date",
  minDate = null,
  maxDate = null,
  error,
  touched
}) {
  return (
    <div className="date-range-picker">
      <DateRangePicker
        startDate={startDate}
        startDateId="start_date_id"
        endDate={endDate}
        endDateId="end_date_id"
        minDate={minDate}
        maxDate={maxDate}
        onDatesChange={({ startDate, endDate }) => handleDatesChange(startDate, endDate)}
        focusedInput={focusedInput}
        onFocusChange={handleFocusChange}
        minimumNights={minimumNights}
        startDatePlaceholderText={startDatePlaceholderText}
        endDatePlaceholderText={endDatePlaceholderText}
        // isOutsideRange={(day) => day.isBefore(minDate) || (maxDate && day.isAfter(maxDate))}
        displayFormat={"MMM D YYYY"}
      />
      {error && touched ? <FormHelperText error={true}>{error}</FormHelperText> : null}
    </div>
  )
}

export default AppDateRange
